import React from "react";
import CmsBlock from "app/layout/cmsBlock";

export const FindARep = () => {
  return <CmsBlock id={"find-a-rep-v2"} />;
};

export const ExploreSectionFindRepText = () => {
  return <CmsBlock id={"explore_section_find_rep_text"} />;
};
export const DownloadCatalog = () => {
  return <CmsBlock id={"download-catalog-v2"} />;
};
